import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, headingStyles } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.section `
  color: var(--accountFgColour);
  position: relative;

  &::before {
    ${transition('transform')};

    position: absolute;
    top: 0;
    right: 0;
    display: block;
    content: '';
    width: 100%;
    aspect-ratio: 1;
    border-radius: 100%;
    background-color: var(--accountArtifactColour);
    transform: translate(20%, -33%) scale(0);
    transform-origin: top right;
  }

  &[data-animate='true']::before {
    transform: translate(20%, -33%) scale(calc(0.66 + var(--progress, 0)));
  }
`;
const Inner = styled.div `
  ${baseGrid};

  position: relative;
`;
const ContentArea = styled.div `
  grid-column: span 24;

  @media ${from(Device.TabletLarge)} {
    grid-column: span 15;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: span 16;
  }
`;
const Title = styled.h1 `
  ${headingStyles};
  font-size: ${fluid(25, 28)};
  line-height: ${fluid(35, 35)};
  margin-bottom: 20px;

  @media ${from(Device.TabletLarge)} {
    margin-bottom: 10px;
  }
`;
const Message = styled.div `
  ${contentStyles};

  p {
    font-size: ${fluid(16, 18)};
    line-height: ${fluid(26, 28)};
  }

  a {
    color: ${brand.primary.base};
  }
`;
const BoxArea = styled.div `
  grid-column: span 24;
  margin-top: 25px;

  @media ${from(Device.TabletLarge)} {
    grid-column: 16 / span 9;
    margin-top: 0;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 17 / span 8;
  }
`;
const Content = styled.div `
  ${contentStyles};

  color: currentColor;
  margin: ${fluid(28, 32)} 0 0;

  > p {
    font-size: ${fluid(18, 20)};
    line-height: ${fluid(28, 30)};
  }
`;
const SupportCard = styled.div `
  background-color: ${brand.secondary.blueGrey};
  border-radius: 10px;
  padding: ${fluid(16, 32, Device.DesktopSmall)} ${fluid(16, 24, Device.DesktopSmall)};
  margin: 0;
  color: ${brand.base.blue};

  ${Content} > p {
    font-size: ${fluid(16, 18)};
    line-height: ${fluid(26, 28)};
    margin: 0 0 ${fluid(20, 24)};
  }
`;
const SupportCardTitle = styled.h3 `
  ${fonts.apparat.semiBold};

  display: flex;
  align-items: center;
  gap: ${fluid(14, 20)};
  font-size: ${fluid(18, 20)};
  line-height: ${fluid(28, 30)};
  margin: 0 0 ${fluid(14, 20)};

  svg {
    display: block;
    width: ${fluid(32, 46, Device.DesktopSmall)};
  }
`;
const TelEmailList = styled.ul `
  li {
    display: flex;
    align-items: center;
    gap: ${fluid(10, 12, Device.DesktopSmall)};
    font-size: ${fluid(16, 18, Device.DesktopSmall)};
    line-height: ${fluid(26, 28)};
    color: currentColor;

    &:not(:last-child) {
      margin: 0 0 ${fluid(10, 14)};
    }
  }

  svg {
    display: block;
    height: ${fluid(14, 18, Device.DesktopSmall)};
    width: ${fluid(14, 18, Device.DesktopSmall)};
  }

  a {
    ${transition('text-decoration-color')};
    ${fonts.apparat.light};

    color: currentColor;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
    text-decoration-color: transparent;

    &.focus-ring {
      outline: auto;
      outline-offset: 3px;
      outline-width: 2px;
      outline-style: solid;
    }

    &.focus-ring,
    &:hover {
      text-decoration-color: currentColor;
    }
  }
`;
const ProfileIntroductionStyles = {
    BoxArea,
    SupportCard,
    SupportCardTitle,
    Container,
    Content,
    ContentArea,
    Inner,
    Message,
    TelEmailList,
    Title,
};
export default ProfileIntroductionStyles;
